var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.705,
    height: 10.964,
    viewBox: "0 0 13.705 10.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M13.02,2H.685A.647.647,0,0,0,0,2.685v9.593a.647.647,0,0,0,.685.685H13.02a.647.647,0,0,0,.685-.685V2.685A.647.647,0,0,0,13.02,2ZM11.032,3.37,6.852,6.591,2.672,3.37Zm1.3,8.223H1.37V4.056L6.441,7.962a.7.7,0,0,0,.822,0l5.071-3.906Z",
    transform: "translate(0 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c195abd28a46713b6ea4b27cf1ff91f0.svg";
export { ForwardRef as ReactComponent };